import { useEffect, useState } from "react";
import { Card, CardBody, CardHeader, Col, Row, Input, Button, Table } from "reactstrap";
import PatientsTableBody from "./PatientsTableBody";
import { Btn, H4, H5 } from "../../../AbstractElements";
import CreateUserModal from "./CreatePatientModal";
import { Link } from "react-router-dom";
import { Search } from 'react-feather';
import axios from "axios";
import { toast } from "react-toastify";
import { getPatientListAction } from "../../../Api/patient";
import ReactPaginate from 'react-paginate';

const PatientsTable: React.FC = () => {
  const [createUserModal, setCreateUserModal] = useState(false)
  const [tempQuery, setTempQuery] = useState("")
  const [loading, setLoading] = useState<boolean>(false);
  const [perPage, setPerPage] = useState<number>(5);

  const [patientItems, setPatientItems] = useState<any>([]);
  const [patientOffset, setPatientOffset] = useState(0);
  const [patientPageCount, setPatientPageCount] = useState(0);
  const draftPatient = localStorage.getItem("draftPatient");
  const [patients, setPatients] = useState<any>([]);

  const getPatients = async () => {
    try {
      setLoading(true)
      const response = await getPatientListAction();

      if (response.status === 'success') {
        const _patients = response.payload
        setPatients(_patients)
      }
      else {
        if (response.response)
          toast.error(response.response.data.message)
        else
          toast.error("Get user list Error!")
      }
      setLoading(false)
    } catch (error) {
      toast.error("Get user list failed!");
    }
  }

  useEffect(() => {
    getPatients()
  }, [])

  useEffect(() => {
    const endPatientOffset = patientOffset + perPage;
    setPatientItems(
      patients.slice(patientOffset, endPatientOffset)
    )

    setPatientPageCount(Math.ceil(patients.length / perPage))
  }, [perPage, patientOffset, patients])

  const handlePageClick = (event: any) => {
    const newOffset = (event.selected * perPage) % patients.length;
    setPatientOffset(newOffset)
  }

  const handleSearch = async () => {
    try {
      setLoading(true)
      const response: any = await axios.get(`/patient/list?query=${tempQuery}`)
      setPatients(response.data.payload.patients)
      setLoading(false)
    } catch (err: any) {
      console.log(err)
      setLoading(false)
    }
  }

  const handleChangePerPage = (e: any) => {
    setPerPage(parseInt(e.target.value))
  }


  return (
    <Col xl="12" className="">
      <Card>
        <CardBody>
          <Row>
            <h5 className="mb-1" style={{ fontSize: 18 }}> {"Browse"}</h5>
            <Col sm={8} className="d-flex mb-3" style={{ gap: 8 }}>
              <Input
                className="border "
                placeholder="Search by name"
                onChange={(e) => {
                  setTempQuery(e.target.value)
                }}
                value={tempQuery} />
              <Button
                className="px-3 pt-2 pb-1"
                onClick={() => handleSearch()}
              >
                <Search width={20} height={18} />
              </Button>
            </Col>
            <Col sm={4} className='d-flex justify-content-end mb-3'>
            </Col>
          </Row>
        </CardBody>
      </Card>
      <Card>
        <CardHeader className={"card-no-border pb-0"}>
          <div className={`header-top`}>
            <H4>{"Patients List"}</H4>
            <Link to="/patient-form" className="btn btn-primary" color="primary">New Patient</Link>
          </div>
        </CardHeader>
        <CardBody className="pt-0 projects px-0">
          <div className="dataTables_wrapper">
            <div className="table-responsive theme-scrollbar">
              <Table className="table display dataTable no-footer" id="selling-product">
                <thead>
                  <tr>
                    <th style={{ minWidth: 60 }}>{"No"}</th>
                    <th style={{ minWidth: 150 }}>{"Name"}</th>
                    <th style={{ minWidth: 150 }}>{"Gender"}</th>
                    <th style={{ minWidth: 225 }}>{"Address"}</th>
                    <th style={{ minWidth: 150 }}>{"Email"}</th>
                    <th style={{ minWidth: 150 }}>{"Phone number"}</th>
                    <th style={{ minWidth: 50 }}>{"Type"}</th>
                    <th style={{ minWidth: 200 }}>{"School"}</th>
                    <th style={{ minWidth: 150 }}>{"Teacher Email"}</th>
                    <th style={{ minWidth: 150 }}>{"GP Email"}</th>
                    <th style={{ minWidth: 120 }}>{"Added At"}</th>
                    <th className="text-center">{"Actions"}</th>
                  </tr>
                </thead>
                <PatientsTableBody patients={patientItems} setPatients={setPatients} />
              </Table>
            </div>
            <div className=" d-flex justify-content-end align-items-center pagination-container mt-3" style={{ gap: 16 }}>

              <div className="d-flex align-items-center items-per-page" style={{ gap: 8 }}>
                <H5>Per Page : </H5>
                <Input
                  type="number"
                  className="border"
                  value={perPage}
                  onChange={(e: any) => handleChangePerPage(e)}
                  style={{ width: 50, textAlign: 'center' }}
                />
              </div>
              <div className="d-flex align-items-center" style={{ gap: 8 }}>
                <div>
                  <ReactPaginate
                    nextLabel=">"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={2}
                    marginPagesDisplayed={1}
                    pageCount={patientPageCount}
                    previousLabel="<"
                    breakLabel="..."
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item page-item-previous"
                    previousLinkClassName="page-link"
                    nextClassName="page-item page-item-next"
                    nextLinkClassName="page-link"
                    breakClassName="page-item page-item-break"
                    breakLinkClassName="page-link"
                    containerClassName="pagination"
                    activeClassName="active"
                  />
                </div>
              </div>
            </div>
          </div>
        </CardBody>
        <CreateUserModal modal={createUserModal} setModal={setCreateUserModal} patients={patients} setPatients={setPatients} />

      </Card>
    </Col>
  );
};

export default PatientsTable;
